import { useMemo } from 'react';
import I18n from 'I18n';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { useLowercaseCrmObjectTypeName } from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
export default function useUnfileAssetsName() {
  const objectType = useObjectTypeId();
  const {
    lowerCaseObjectTypeNamePlural,
    capitalizedObjectTypeNamePlural
  } = useLowercaseCrmObjectTypeName({
    objectTypeIdArg: objectType
  });
  const assetName = useMemo(() => {
    return I18n.text('frameworkListingLib.folders.unfiledObjectTypeWithName', {
      objectTypeName: lowerCaseObjectTypeNamePlural,
      capitalizedObjectTypeName: capitalizedObjectTypeNamePlural
    });
  }, [lowerCaseObjectTypeNamePlural, capitalizedObjectTypeNamePlural]);
  return assetName;
}